import { api } from "../api/client";

export type User = {
  user_id: string;
  email: string;
  role: "admin" | "user";
};

export async function login(
  email: string,
  password: string,
): Promise<{ user: User; token: string }> {
  const { data } = await api.post<{ user: User; token: string }>("/auth/login", {
    email,
    password,
  });
  return { user: data.user, token: data.token };
}

export async function logout(): Promise<void> {
  await api.post("/auth/logout");
}

export async function me(): Promise<{ user: User; token: string } | null> {
  try {
    const { data } = await api.get<{ user: User; token: string }>("/auth/me");
    return { user: data.user, token: data.token };
  } catch {
    return null;
  }
}
